function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.6909 7.45455H1.30909V12.2909C1.30909 13.1746 2.02544 13.8909 2.90909 13.8909H13.0909C13.9746 13.8909 14.6909 13.1746 14.6909 12.2909V7.45455ZM14.6909 6.14545H1.30909V4.65455C1.30909 3.77089 2.02544 3.05455 2.90909 3.05455H13.0909C13.9746 3.05455 14.6909 3.77089 14.6909 4.65455V6.14545ZM16 4.65455C16 3.0479 14.6976 1.74545 13.0909 1.74545H2.90909C1.30244 1.74545 0 3.0479 0 4.65455V12.2909C0 13.8976 1.30244 15.2 2.90909 15.2H13.0909C14.6976 15.2 16 13.8976 16 12.2909V4.65455Z",
  fill: "#738BA5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.34545 0C4.70695 0 5 0.29305 5 0.654545V3.72727C5 4.08877 4.70695 4.38182 4.34545 4.38182C3.98396 4.38182 3.69091 4.08877 3.69091 3.72727V0.654545C3.69091 0.29305 3.98396 0 4.34545 0Z",
  fill: "#738BA5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.7455 0C12.1069 0 12.4 0.29305 12.4 0.654545V3.72727C12.4 4.08877 12.1069 4.38182 11.7455 4.38182C11.384 4.38182 11.0909 4.08877 11.0909 3.72727V0.654545C11.0909 0.29305 11.384 0 11.7455 0Z",
  fill: "#738BA5"
});

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.eaee0015.svg";
export { ForwardRef as ReactComponent };